<div>
  <h2>{{ 'Administration::RedactionSettings' | abpLocalization }}</h2>
</div>
<br />
<hr />
@if (form) {
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <div class="mt-2 fade-in-top">
      <div class="form-group form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="isServiceEnabled"
          formControlName="isServiceEnabled"
        />
        <label class="form-check-label" for="isServiceEnabled">
          {{ 'Administration::RedactionSettings:EnableMasking' | abpLocalization }}
        </label>
      </div>

      @if (!redactionSettings.isServiceUnavailable && form.get('isServiceEnabled').value) {
        <div class="form-group ms-4">
          <div class="form-check mt-3">
            <input
              class="form-check-input"
              type="radio"
              id="dynamicMasking"
              formControlName="type"
              value="0"
            />
            <div class="d-flex flex-column">
              <label class="form-check-label" for="dynamicMasking">
                {{ 'Administration::RedactionSettings:DynamicMasking' | abpLocalization }}
              </label>
              <span class="form-text text-muted">
                {{
                  'Administration::RedactionSettings:DynamicMaskingInformation' | abpLocalization
                }}
              </span>
            </div>
          </div>
          <div class="form-check mt-3">
            <input
              class="form-check-input"
              type="radio"
              id="staticMasking"
              formControlName="type"
              value="1"
            />
            <div class="d-flex flex-column">
              <label class="form-check-label" for="staticMasking">
                {{ 'Administration::RedactionSettings:StaticMasking' | abpLocalization }}
              </label>
              <span class="form-text text-muted">
                {{ 'Administration::RedactionSettings:StaticMaskingInformation' | abpLocalization }}
              </span>
            </div>
          </div>
        </div>

        <h4 class="mt-4">
          {{ 'Administration::RedactionSettings:MaskingMode' | abpLocalization }}
        </h4>

        <div class="form-group">
          <div class="form-check mt-3">
            <input
              class="form-check-input"
              type="radio"
              id="replaceWithPIIType"
              formControlName="mode"
              value="0"
            />
            <div class="d-flex flex-column">
              <label class="form-check-label" for="replaceWithPIIType">
                {{ 'Administration::RedactionSettings:ReplaceWithPIIType' | abpLocalization }}
              </label>
              <span class="form-text text-muted">
                {{
                  'Administration::RedactionSettings:ReplaceWithPIITypeInformation'
                    | abpLocalization
                }}
              </span>
            </div>
          </div>
          <div class="form-check mt-3">
            <input
              class="form-check-input"
              type="radio"
              id="replaceWithCharacter"
              formControlName="mode"
              value="1"
            />
            <div class="d-flex flex-column">
              <label class="form-check-label" for="replaceWithCharacter">
                {{ 'Administration::RedactionSettings:ReplaceWithCharacter' | abpLocalization }}
              </label>
              <span class="form-text text-muted">
                {{
                  'Administration::RedactionSettings:ReplaceWithCharacterInformation'
                    | abpLocalization
                }}
              </span>
            </div>
          </div>
        </div>

        <h4 class="mt-4">
          {{ 'Administration::RedactionSettings:PIIToBeMasked' | abpLocalization }}
        </h4>

        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="selectAll"
            formControlName="selectAll"
            (change)="onClickedSelectAll($event.currentTarget.checked)"
          />
          <label class="form-check-label" for="selectAll">
            {{ 'Administration::RedactionSettings:SelectAll' | abpLocalization }}
          </label>
        </div>

        <br />

        <div formGroupName="properties" class="properties-grid">
          @for (property of redactionSettings.properties; track property) {
            <div class="form-group">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="{{ property.phraseType }}"
                  formControlName="{{ property.phraseType }}"
                  [checked]="property.isSelected"
                  (change)="onPhraseTypeChanged()"
                />
                <label class="form-check-label" for="{{ property.phraseType }}">
                  {{ getDisplayName(property) }}
                  <span class="text-muted">{{ getLanguageCodes(property) }}</span>
                </label>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <abp-button (click)="submitForm()" iconClass="fa-solid fa-check" [loading]="isLoading">
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </form>
}
